UC.modals.ModalPendingUser = Backbone.View.extend({
  el: '#modalPendingUser',

  render: function(message) {
    if (message) this.$el.find('h4.modal-title').text(message);

    this.$el.modal();
  }
});
